import _ from 'underscore';
import struct from 'observ-struct';
import xtend from 'xtend';

import Store from '../../../lib/store/store-v2';

const KEY = 'categoryID';


function deepClone (obj) {
    var clone = {};
    for (var parent in obj) {
        if (obj.hasOwnProperty(parent)) {
            for (var child in obj[parent]) {
                if (obj[parent].hasOwnProperty(child)) {
                    clone[parent] = _.clone(obj[parent][child]);
                }
            }
        }
    }
    return clone;
}

// This is absolutely nuts
// save yourself
export default function (apiBus, socketBus) {

    var state = Store();
    var nested = {};

    /**
     * When Category Properties change, update the `nested` categories to reflect
     * what changes were made.
     *
     * PID = parentCategoryID
     *
     * If a category has a PID set, ensure the nested `PID` exists or create it.
     *
     * If a parent doesn't have an object of the category's categoryID, set
     * the categoryID property of the parent as the new child.
     *
     * If the parent has the child already but new data states that the PID no
     * longer is set, delete the nested version of the category.
     *
     * If the parent has the child already but the new data does as well (UPDATE)
     * then merge the two, the newest version (data) taking precidence.
     */
    state.data(function onChange (data) {
        // console.info('change');

        // @XXX Deep clone
        var clone = deepClone(nested);

        // Loop through the updated state data
        for (var id in data) {
            /**
             * This check handles weirdness when deletes occur within a for..in loop:
             * - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...in
             */
            if (data.hasOwnProperty(id)) {
                var category = data[id];

                // If the category has a parentCategoryID set ...
                if (category.parentCategoryID != null) {

                    // Create the parent category container if it isn't there
                    if (!clone.hasOwnProperty(category.parentCategoryID)) {
                        // console.info('creating parent', category.parentCategoryID);
                        clone[category.parentCategoryID] = {};
                    }

                    // If the child isn't set
                    if (!clone[category.parentCategoryID].hasOwnProperty(category.categoryID)) {
                        // console.log('Setting child', category);
                        clone[category.parentCategoryID][category.categoryID] = category;
                    } else if (!_.isEqual(clone[category.parentCategoryID][category.categoryID], category)) {
                        // It has been set/clone previous to this update cycle
                        // UPDATE the information
                        // console.info('updating child', clone, category);
                        clone[category.parentCategoryID][category.categoryID] = xtend(
                            clone[category.parentCategoryID][category.categoryID],
                            category
                        );
                    } else {
                        // console.log('Bypassing child', category.categoryID, category.categoryName);
                    }
                }
            }
        }


        // Delete any straggling parents with no children
        for (var parent in clone) {
            if (clone.hasOwnProperty(parent)) {
                if (!data.hasOwnProperty(parent)) {
                    // console.info('deleting parent', clone, parent);
                    // Ensure that all the children are updated such that they
                    // no longer appear as a child to a nonexistent parent
                    for (var child in clone[parent]) {
                        if (clone[parent].hasOwnProperty(child) && clone[parent][child].parentCategoryID) {
                            clone[parent][child].parentCategoryID = null;
                        }
                    }
                    delete clone[parent];
                } else {
                    // Loop through all clone children and if PID in categoryID
                    // remove it from the parent as it is now updated to NULL
                    for (var child in clone[parent]) {
                        if (clone[parent].hasOwnProperty(child)) {
                            if (!data.hasOwnProperty(child) || data[child].parentCategoryID != parent) {
                                // console.info('deleting child', clone, parent, child);
                                delete clone[parent][child];
                            } else {
                                // console.log('found child in state', data, parent, child);
                            }
                        }
                    }
                }
            }
        }

        nested = clone;
    });


    /**
     * Arbitrarily renames childOf to parentCategoryID for the sake of consistency
     * here as well in the views.
     * - crud.v3 shows 'childOf' instead of 'parentCategoryID'.
     * - api.v3 shows `parentCategoryID`
     *
     * @param  {Object} category A Category
     * @return {Object}          A Category with `parentCategoryID` instead of `childOf`
     */
    function sanitizeCategory (category) {
        var clone = _.clone(category);
        if (clone.hasOwnProperty('childOf')) {
            clone.parentCategoryID = clone.childOf;
            delete clone.childOf;
        }
        return clone;
    }


    /**
     * Update a category
     *
     * @param  {Object} event Websocket or Api response
     * @return {void}
     */
    function handleUpdate (event) {
        // console.log('handleUpdate', state(), event);
        var { data } = state();
        var category = event.data;

        category = sanitizeCategory(category);

        if (data.hasOwnProperty(category.categoryID)) {
            var updates = {};
            updates[category.categoryID] = xtend(
                updates[category.categoryID],
                category
            );
            state.set(xtend(state(), {
                isResolving: false,
                data: xtend(data, updates)
            }));
        } else {
            console.warn('No Update Made!', category, data);
        }
    }

    /**
     * Add a new Category to State (or, in the event it's already there and a
     * latent Websocket was pushed, then update it (XXX maybe ignore it???))
     *
     * @param  {Object} event Websocket or Api response
     * @return {void}
     */
    function handleCreate (event) {
        // console.log('handleCreate', state(), event);
        var { data } = state();
        var category = event.data;
        category = sanitizeCategory(category);

        if (!data.hasOwnProperty(category.categoryID)) {
            var updates = {};
            updates[category.categoryID] = category;
            state.set(xtend(state(), {
                isResolving: false,
                data: xtend(data, updates)
            }));
        } else {
            console.warn('CREATE: Category Already Exists! Calling Update...', event);
            handleUpdate(event);
        }
    }

    /**
     * Delete a Category in State
     *
     * @param  {Object} event Websocket or Api response
     * @return {void}
     */
    function handleDelete (event) {
        // console.log('handleDelete', state(), event);
        var { data } = state();
        var category = event.data;
        if (data.hasOwnProperty(category.categoryID)) {
            // This was a pain in the buns
            // calling delete on data updated the state by reference
            var clone = _.clone(data);
            delete clone[category.categoryID];
            state.set(xtend(state(), {
                isResolving: false,
                data: clone
            }));
        } else {
            console.warn('No Deletion Made!', category, data);
        }
    }

    var apiActions = Store.ApiActions(state, KEY, {
        get: function (event) {
            state.set({
                isResolving: false,
                data: _(event.data).indexBy(KEY)
            });
        },
        add: handleCreate,
        edit: handleUpdate,
        delete: handleDelete
    });

    var socketActions = Store.WebsocketActions(state, KEY, {
        add: handleCreate,
        edit: handleUpdate,
        delete: handleDelete
    });

    Store.SubscribeToApi(apiActions, apiBus);
    var allEvents = Store.WebsocketEvents;
    Store.SubscribeToWebsocket(allEvents, socketActions, socketBus);

    return {
        state: Store.Parse(state, function (data) {
            return (xtend(data, {
                data: _.toArray(data.data),
                nested: nested
            }));
        })
    };
};
